import { render, staticRenderFns } from "./loadingBtn.vue?vue&type=template&id=4fa9495e&scoped=true"
import script from "./loadingBtn.vue?vue&type=script&lang=js"
export * from "./loadingBtn.vue?vue&type=script&lang=js"
import style0 from "./loadingBtn.vue?vue&type=style&index=0&id=4fa9495e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa9495e",
  null
  
)

export default component.exports